import {EventEmitter, Injectable} from '@angular/core';
import {Http, RequestOptions, Headers} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {UserDetails} from "./user-details.model";
import {environment} from "../../../environments/environment";
import {OnBoardLocalStoreService} from "../on-board-local-store.service";

@Injectable()
export class AuthenticationService {

  // Observable string streams
  private _authStatusChangeEventEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  // ========================================================================
  private _currentUser: UserDetails;

  public _errorMsg: string;

  constructor(private _http: Http,
              private _store: OnBoardLocalStoreService) {
    this._currentUser = this._store._getCurrentUser();
  }

  public login(username: string,  password: string): Observable<UserDetails> {
    let bodyString: string = "username=" + username + "&password=" + password;
    let headers: Headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
    let options = new RequestOptions({headers: headers, withCredentials: true});

    const url: string = environment.BASE_BACKEND_URL + "login/";
    return this._http.post(url, bodyString, options)
      .map( res => res.json().body as UserDetails)
      .do( data => {
        this._store._saveCurrentUser(this._currentUser);
        this._authStatusChangeEventEmitter.emit(true);
      });
  }

  public getAuthStatusChangeEventEmitter() {
    return this._authStatusChangeEventEmitter;
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/auth/authentication.service.ts